import React, { useEffect } from 'react';

import { Box, Button, Divider, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    ReactHookFormInput,
    ReactHookFormSelect,
} from 'common/components/form';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import { getLanguageOptions } from '../helpers';
import * as selectors from '../selectors';
import validate from '../validate';

const TemplateForm = ({ filterData, initialValues, save }) => {
    const { t } = useTranslation();

    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    useEffect(() => reset(initialValues), [initialValues]);

    const handleClickSave = (values) => save(filterData, values);

    return (
        <Stack component="form" onSubmit={handleSubmit(handleClickSave)}>
            <ReactHookFormInput
                control={control}
                label={`${t('Title')} *`}
                name="name"
                sx={{ mb: 2 }}
            />

            <ReactHookFormSelect
                control={control}
                label={t('Language')}
                name="language"
                options={getLanguageOptions()}
            />

            <Divider sx={{ mx: (theme) => `${theme.spacing(-2)}!important` }} />

            <Box sx={{ textAlign: 'right' }}>
                <Button type="submit">{t('Save')}</Button>
            </Box>
        </Stack>
    );
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialValues,
});

const mapDispatchToProps = (dispatch) => ({
    save: (filterData, values) => dispatch(actions.save(filterData, values)),
});

TemplateForm.propTypes = {
    filterData: PropTypes.object,
    initialValues: PropTypes.object,
    save: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateForm);
